import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { combineLatest, map, Observable, shareReplay, take } from "rxjs";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { EstrategiaSeguir } from "src/app/shared/model/gestion-proyectos/riesgos/estrategia-aseguir.model";
import { FaseDeteccion } from "src/app/shared/model/gestion-proyectos/riesgos/fase-deteccion.model";
import { Impacto } from "src/app/shared/model/gestion-proyectos/riesgos/impacto.model";
import { Periodicidad } from "src/app/shared/model/gestion-proyectos/riesgos/periodicidad.model";
import { Probabilidad } from "src/app/shared/model/gestion-proyectos/riesgos/probabilidad.model";
import { Riesgos } from "src/app/shared/model/gestion-proyectos/riesgos/riesgo.model";
import { SeveridadRiesgo } from "src/app/shared/model/gestion-proyectos/riesgos/severidad-riesgo.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import { MatStepperModule } from '@angular/material/stepper'; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@Component({
    selector: 'app-evaluacion-riesgo',
    templateUrl: './evaluacion-riesgo.component.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatSelectSearchModule,
          MatStepperModule
      ]
})
export class EvaluacionRiesgoComponent implements OnInit{

    readonly periodicidad$: Observable<Periodicidad[]>;
    readonly impacto$: Observable<Impacto[]>;
    readonly probabilidad$: Observable<Probabilidad[]>;
    readonly severidad$: Observable<SeveridadRiesgo[]>;
    readonly estrategia$: Observable<EstrategiaSeguir[]>;

    constructor(private service: ProyectosService) {
        this.periodicidad$ = this.obtenerPeriodicidad();
        this.impacto$ = this.obtenerImpactos();
        this.probabilidad$ = this.obtenerProbabilidad();
        this.severidad$ = this.obtenerSeveridad();
        this.estrategia$ = this.obtenerEstrategia();
    }

    @Input() riesgo: Riesgos;
    @Input() evaluacionRiesgoGroup: FormGroup;
    probabilidadXImpacto: number;
    colorSeveridad: String;
    nombreSeveridad: string;
    



    ngOnInit(){
        if(this.riesgo?.id != null && this.riesgo.severidad){
            this.colorSeveridad = this.riesgo.severidad.color;
            this.nombreSeveridad = this.riesgo.severidad.descripcion;
        }
    }

    private obtenerProbabilidad(): Observable<Probabilidad[]> {
        return this.obtenerCatalogo(UrlConstantes.consultaProbabilidad);
    }
    private obtenerSeveridad(): Observable<SeveridadRiesgo[]> {
        return this.obtenerCatalogo(UrlConstantes.consultaSeveridad);
    }
    private obtenerEstrategia(): Observable<EstrategiaSeguir[]> {
        return this.obtenerCatalogo(UrlConstantes.consultaEstrategia);
    }
    private obtenerPeriodicidad(): Observable<Periodicidad[]> {
        return this.obtenerCatalogo(UrlConstantes.consultaPeriodicidad);
    }
    private obtenerImpactos(): Observable<Impacto[]> {
        return this.obtenerCatalogo(UrlConstantes.consultaImpactos);
    }

    private obtenerCatalogo<T>(url: string): Observable<T[]> {
        return this.service.consultaGeneral(url).pipe(
            map((res) => res?.list ?? []),
            shareReplay({ bufferSize: 1, refCount: true })
        );
    }

    calcularProbabilidadImpacto(){
        const idImpacto = this.evaluacionRiesgoGroup.get('impactoCtrl')?.value;
        const idProbabilidad = this.evaluacionRiesgoGroup.get('probabilidadCtrl')?.value;
        this.riesgo.id_impacto = idImpacto;
        this.riesgo.id_probabilidad = idProbabilidad;
        combineLatest([this.impacto$, this.probabilidad$, this.severidad$]).pipe(take(1)).subscribe(([impactos, probabilidades, severidades]) => {
            const impacto = impactos.find(opcion => opcion.id_impacto == idImpacto);
            const probabilidad = probabilidades.find(opcion => opcion.id_probabilidad == idProbabilidad);

            if (!impacto || !probabilidad) {
                return;
            }
            const impactoValor=impacto.valor
            const probabilidadValor=probabilidad.valor
            this.probabilidadXImpacto = probabilidadValor * impactoValor;
            this.riesgo.calculo_severidad=this.probabilidadXImpacto;
            for (let i = 0; i < severidades.length; i++) {
                if (this.probabilidadXImpacto >= severidades[i].rango_inicial && this.probabilidadXImpacto <= severidades[i].rango_final) {
                    this.riesgo.id_severidad = severidades[i].id_severidad;
                    this.colorSeveridad=severidades[i].color;
                    this.nombreSeveridad=severidades[i].descripcion;
                }
            }
        });

    }
}
